import { render, staticRenderFns } from "./NameChangeApplicationConfirmation.vue?vue&type=template&id=237eaa9a&scoped=true&"
import script from "./NameChangeApplicationConfirmation.vue?vue&type=script&lang=js&"
export * from "./NameChangeApplicationConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./NameChangeApplicationConfirmation.vue?vue&type=style&index=0&id=237eaa9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237eaa9a",
  null
  
)

export default component.exports